import { useSelector } from 'react-redux';

const useFeatureToggle = () => {
  const features = useSelector(state => state.tenant.features);
  const clientAssets = useSelector(state => state.tenant.clientAssets);
  const authProviders = useSelector(state => state.tenant.providers);
  const isTenantConfigLoaded = useSelector(state => state.tenant.config !== null);

  return {
    isTenantConfigLoaded,
    isEnabled: featureKey => {
      if (Array.isArray(features)) {
        return features.includes(featureKey);
      }
      return features?.[featureKey] === true;
    },
    getFeatures: () => features || {},
    getClientAssets: () => clientAssets,
    getAuthProviders: () => authProviders || [],
    hasAuthProvider: type => authProviders?.some(provider => provider.type === type) || false
  };
};

export default useFeatureToggle;
